import Axios from "axios";
import Swal from "sweetalert2";
import { getCurrentYearMonth } from "./DateUtils";

// ดึงข้อมูลจาก Table ใดๆ ก็ได้
const getData = async (table, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
const getDataWithComp = async (table, order) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-comp`,
      {
        table: table,
        order: order,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ และสามารถ JOIN Table ได้ด้วย
const getDataWithJoin = async (select, table, join, order) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-join`,
      {
        select: select,
        table: table,
        join: join,
        order: order,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// นับรายการจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
const countData = async (table, where) => {
  const response = await Axios.post(
    `${process.env.REACT_APP_API_URL}/api/count-data`,
    {
      table: table,
      where: where,
      comp_id: window.localStorage.getItem("company"),
    },
    {
      headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
    }
  );
  return response.data[0].Count;
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ DocId
const getByDocId = async (table, docId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-doc-id`,
      {
        table: table,
        doc_id: docId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ RecId
const getByRecId = async (table, recId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-rec-id`,
      {
        table: table,
        rec_id: recId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ PayId
const getByPayId = async (table, payId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-pay-id`,
      {
        table: table,
        pay_id: payId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_Company
const getCompany = async () => {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-company`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_DocType
const getDocType = async (docCode) => {
  try {
    // const response = await Axios.get(`${process.env.REACT_APP_API_URL}/api/get-doc-type`, {
    //     headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
    // });
    // return response.data;

    const response = await getData(
      "Tb_Set_DocType",
      `DocType_Status = 'Y' AND DocType_DocCode = ${docCode}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_TransType
const getTransType = async () => {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-trans-type`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_DocStatusColour
const getDocStatusColour = async (docCode, docField) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-doc-status-colour`,
      {
        doc_code: docCode,
        doc_field: docField,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Pr
const getViewPrH = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-pr-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Po
const getViewPoH = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-po-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Ap
const getViewAp = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-ap`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;

  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Item
const getViewItem = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-item`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก API_0701_SO_H ที่ยังไม่ได้สร้าง Picking List
const getSoWithoutPK = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-so-by-picking-list`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะลูกค้า
const getCustByType = async (whDocType, condition) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-cust-by-wh-doc-type`,
      {
        wh_doc_type: whDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะพนักงาน
const getEmpByType = async (wtDocType, condition) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-emp-by-wh-doc-type`,
      {
        wt_doc_type: wtDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Popup แจ้งเตือน ต่างๆ
const getAlert = (status, message, callback) => {
  let icon = "";
  let confirmButtonClass = "";
  let cancelButtonClass = "btn btn-danger"; // Default cancel button class

  switch (status) {
    case "OK":
      icon = "success";
      confirmButtonClass = "btn btn-success";
      break;
    case "FAILED":
      icon = "error";
      confirmButtonClass = "btn btn-danger";
      break;
    case "WARNING":
      icon = "warning";
      confirmButtonClass = "btn btn-warning";
      break;
    case "INFO":
      icon = "info";
      confirmButtonClass = "btn btn-info";
      break;
    case "C_DIALOG":
      icon = message === "ยืนยันการลบข้อมูล" ? "question" : "info";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";
      Swal.fire({
        title: message,
        icon: icon,
        showCancelButton: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        buttonsStyling: true, // ปิดการใช้งาน styling เริ่มต้นของปุ่ม
        customClass: {
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          if (callback) {
            callback(true);
          }
        } else {
          if (callback) {
            callback(false);
          }
        }
      });
      return; // ออกจากฟังก์ชันไม่ต้องทำงานต่อ
    default:
      console.error(`Invalid status: ${status}`);
      return;
  }

  // เลื่อนหน้าขึ้นด้านบนสุด
  window.scrollTo(0, 0);

  Swal.fire({
    title: message,
    icon: icon,
    buttonsStyling: false,
    customClass: {
      confirmButton: confirmButtonClass,
    },
  });
};

// ฟังก์ชันสำหรับจัดรูปแบบจำนวนเงิน
const formatCurrency = (amount) => {
  // ตรวจสอบว่า amount เป็นประเภท number
  if (typeof amount !== "number" || isNaN(amount)) {
    return "0.00";
  }

  // แปลงจำนวนเงินให้เป็นทศนิยม 2 ตำแหน่ง
  const formattedAmount = amount.toFixed(2);

  // ตรวจสอบว่ามีรูปแบบที่จัดรูปแบบแล้วอยู่หรือไม่
  const regex = /^\d{1,3}(?:,\d{3})*(?:\.\d{2})?$/;
  // ตรวจสอบว่าค่าเป็นประเภท string และมีรูปแบบที่จัดรูปแบบแล้วหรือไม่
  if (regex.test(formattedAmount)) {
    return formattedAmount; // คืนค่าเดิมถ้ามีการ format เรียบร้อยแล้ว
  }

  // เพิ่ม , เพื่อจัดรูปแบบจำนวนเงิน
  return formattedAmount.replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

// ฟังก์ชันสำหรับแปลงรูปแบบจำนวนเงินกลับไปเป็นตัวเลขธรรมดา
const parseCurrency = (formattedAmount) => {
  // ตรวจสอบว่า formattedAmount เป็น null หรือว่าง
  if (formattedAmount == null || formattedAmount === "") {
    return formattedAmount;
  }

  if (typeof formattedAmount === "number") return formattedAmount;
  if (typeof formattedAmount !== "string") return NaN;

  // ลบช่องว่างและเครื่องหมายพันหลัก ถ้าไปโดนฟังชั่น formatCurrency แปลงค่ามา
  const cleanedAmount = formattedAmount.replace(/,/g, "").trim();

  // แปลงค่ากลับไปเป็นตัวเลขเหมือนเดิม สมมุติ 100,400.00 จะแปลงเป็น 100400 (เคสที่พี่คินแจ้งมา)
  const numericValue = parseFloat(cleanedAmount);

  // ตรวจสอบว่าผลลัพธ์เป็นตัวเลขที่ถูกต้อง (ห้ามโยนกลับไปเป็น String เด็ดขาด ไม่งั้นเราจะชิปหายกันหมด)
  return isNaN(numericValue) ? formattedAmount : numericValue;
};

const getMaxDocNo = (list, title) => {
  const { currentYear, currentMonth, shortYear } = getCurrentYearMonth2();

  // กรองเฉพาะเอกสารที่ขึ้นต้นด้วย title (เช่น "INV", "QT")
  const filteredList = list?.filter((item) => item.Doc_No.startsWith(title));

  if (!filteredList || filteredList.length < 1) {
    console.debug("ไม่มีเอกสารที่ขึ้นต้นด้วย", title, "สร้างใหม่");
    if (title === "QT") {
      return `${title}${currentYear}${currentMonth}-0001`; // QT รีเซ็ตทุกปี และเพิ่ม "-"
    }
    if (title === "INV") {
      return `${title}${shortYear}${currentMonth}001`;
    } else {
      const newTitle = title === "REC" ? "RC" : title;
      return `${newTitle}${shortYear}${currentMonth}0001`;
    }
    // เอกสารอื่นเริ่มต้น 0001 (ไม่มี "-")
  }

  // จัดเรียงเอกสารจากมากไปน้อย (Doc_ID มากสุดก่อน)
  const sortedDocs = filteredList.sort((a, b) => b.Doc_ID - a.Doc_ID);
  const maxDoc = sortedDocs[0].Doc_No; // เอา Doc_No ล่าสุด

  // ดึงปีและเดือนจากเอกสารล่าสุด
  let docYear, docMonth;
  if (title === "QT") {
    docYear = maxDoc.slice(2, 6); // YYYY
    docMonth = maxDoc.slice(6, 8); // MM
  } else {
    // ตรวจสอบความยาว prefix จาก maxDoc จริง
    if (maxDoc.startsWith("RC") && !maxDoc.startsWith("REC")) {
      docYear = maxDoc.slice(2, 4);
      docMonth = maxDoc.slice(4, 6);
    } else {
      docYear = maxDoc.slice(3, 5); // YY
      docMonth = maxDoc.slice(5, 7); // MM
    }
  }

  console.debug("📅 ปีในเอกสาร:", docYear, "เดือน:", docMonth);

  // **เงื่อนไขเฉพาะของ QT (รีเซ็ตทุกปี)**
  if (title === "QT" && docYear !== currentYear.toString()) {
    console.debug("🔄 ปีใหม่ รีเซ็ตเลขรันสำหรับ QT");
    return `${title}${currentYear}${currentMonth}-0001`;
  }

  // **เงื่อนไขเฉพาะของ INV (รีเซ็ตทุกเดือน)**
  if (title === "INV" && (docYear !== shortYear || docMonth !== currentMonth)) {
    console.debug("🔄 เดือนใหม่ รีเซ็ตเลขรันสำหรับ INV");
    return `${title}${shortYear}${currentMonth}001`;
  }

  // ถ้าเป็นเดือนเดิม ให้เพิ่มเลขรันต่อ
  const nextDocNo = incrementDocNo(
    maxDoc,
    title,
    currentYear,
    currentMonth,
    shortYear
  );
  console.debug("🆕 หมายเลขเอกสารถัดไป:", nextDocNo);
  return nextDocNo;
};

// Keep the running number continuous across months, but use the year/month
// from the selected document date. dateString is DD-MM-BBBB (Buddhist year).
const getMaxDocNoByDate = (list, title, dateString) => {
  if (!dateString || typeof dateString !== "string") {
    return getMaxDocNo(list, title);
  }

  const dateParts = dateString.split("-");
  if (dateParts.length !== 3) {
    return getMaxDocNo(list, title);
  }

  const [, monthValue, yearValue] = dateParts;
  const month = monthValue.padStart(2, "0");
  const shortYear = yearValue.slice(-2);
  const prefix = `${title}${shortYear}${month}`;

  const runningNumbers = (list || [])
    .map((item) => item.Doc_No)
    .filter(
      (docNo) => typeof docNo === "string" && docNo.startsWith(prefix)
    )
    .map((docNo) => Number.parseInt(docNo.slice(prefix.length), 10))
    .filter((running) => Number.isInteger(running));

  const nextRunning =
    (runningNumbers.length > 0 ? Math.max(...runningNumbers) : 0) + 1;

  return `${prefix}${nextRunning.toString().padStart(4, "0")}`;
};

const getMaxDocInvNo = (list, title) => {
  const { currentYear, currentMonth, shortYear } = getCurrentYearMonth2();

  // กรองเฉพาะเอกสารที่ขึ้นต้นด้วย title (เช่น "INV", "QT")
  const filteredList = list?.filter((item) => item.Doc_INV_No.startsWith(title));

  if (!filteredList || filteredList.length < 1) {
    console.debug("ไม่มีเอกสารที่ขึ้นต้นด้วย", title, "สร้างใหม่");
    if (title === "QT") {
      return `${title}${currentYear}${currentMonth}-0001`; // QT รีเซ็ตทุกปี และเพิ่ม "-"
    }
    if (title === "INV") {
      return `${title}${shortYear}${currentMonth}001`;
    } else {
      return `${title}${shortYear}${currentMonth}001`;
    }
    // เอกสารอื่นเริ่มต้น 0001 (ไม่มี "-")
  }

  // จัดเรียงเอกสารจากมากไปน้อย (Doc_ID มากสุดก่อน)
  const sortedDocs = filteredList.sort((a, b) => b.Doc_INV_No - a.Doc_INV_No);
  const maxDoc = sortedDocs[0].Doc_INV_No

  // ดึงปีและเดือนจากเอกสารล่าสุด
  let docYear, docMonth;
  if (title === "QT") {
    docYear = maxDoc.slice(2, 6); // YYYY
    docMonth = maxDoc.slice(6, 8); // MM
  } else {
    // ตรวจสอบความยาว prefix จาก maxDoc จริง
    if (maxDoc.startsWith("RC") && !maxDoc.startsWith("REC")) {
      docYear = maxDoc.slice(2, 4);
      docMonth = maxDoc.slice(4, 6);
    } else {
      docYear = maxDoc.slice(3, 5); // YY
      docMonth = maxDoc.slice(5, 7); // MM
    }
  }

  console.debug("📅 ปีในเอกสาร:", docYear, "เดือน:", docMonth);

  // **เงื่อนไขเฉพาะของ QT (รีเซ็ตทุกปี)**
  if (title === "QT" && docYear !== currentYear.toString()) {
    console.debug("🔄 ปีใหม่ รีเซ็ตเลขรันสำหรับ QT");
    return `${title}${currentYear}${currentMonth}-0001`;
  }

  // **เงื่อนไขเฉพาะของ INV (รีเซ็ตทุกเดือน)**
  if (title === "INV" && (docYear !== shortYear || docMonth !== currentMonth)) {
    console.debug("🔄 เดือนใหม่ รีเซ็ตเลขรันสำหรับ INV");
    return `${title}${shortYear}${currentMonth}001`;
  }

  // **เงื่อนไขสำหรับ RC หรือ REC (รีเซ็ตทุกเดือน)**
  if (
    (title === "RC" || title === "REC") &&
    (docYear !== shortYear || docMonth !== currentMonth)
  ) {
    console.debug(`🔄 เดือนใหม่ รีเซ็ตเลขรันสำหรับ ${title}`);
    const newTitle = title === "REC" ? "RC" : title;
    // const suffix = title === "RC" || title === "REC" ? "0001" : "001"; // เดิม
    return `${newTitle}${shortYear}${currentMonth}0001`;
  }

  // ถ้าเป็นเดือนเดิม ให้เพิ่มเลขรันต่อ
  const nextDocNo = incrementDocNo(
    maxDoc,
    title,
    currentYear,
    currentMonth,
    shortYear
  );
  console.debug("🆕 หมายเลขเอกสารถัดไป:", nextDocNo);
  return nextDocNo;
};

const incrementDocNo = (docNo, title, currentYear, currentMonth, shortYear) => {
  console.debug("🔢 กำลังเพิ่มเลขเอกสาร:", docNo);

  if (title === "QT") {
    const numPart = parseInt(docNo.slice(9), 10) + 1; // ตัดเลขรันหลัง "-"
    const prefix = `${title}${currentYear}${currentMonth}`; // ใช้ปีเดือนปัจจุบัน
    return `${prefix}-${numPart.toString().padStart(4, "0")}`;
  } else {
    // ตรวจสอบความยาวของ prefix (เช่น RC=2, REC=3, INV=3)
    let prefixLength = 3; // ค่าเริ่มต้นสำหรับ INV, REC ฯลฯ
    if (docNo.startsWith("RC") && !docNo.startsWith("REC")) {
      prefixLength = 2;
    }

    // ตัดส่วนที่เป็นวันที่ออก (prefix + 4 ตัวสำหรับ YYMM)
    const dateLength = 4;
    const sliceIndex = prefixLength + dateLength;

    const numPart = parseInt(docNo.slice(sliceIndex), 10) + 1;

    // เปลี่ยนจาก REC เป็น RC
    const targetTitle = (title === "REC") ? "RC" : title;
    const prefix = `${targetTitle}${shortYear}${currentMonth}`; // ใช้ปีเดือนปัจจุบัน

    // กำหนดความยาวของตัวเลข running (RC/REC ใช้ 4 หลัก, INV ใช้ 3 หลัก)
    const padding = (title === "RC" || title === "REC") ? 4 : 3;

    return `${prefix}${numPart.toString().padStart(padding, "0")}`;
  }
};

// ฟังก์ชันดึงปีและเดือน
const getCurrentYearMonth2 = () => {
  const now = new Date();
  const currentYear = now.getFullYear(); // ค.ศ. 2025
  const shortYear = (currentYear + 543).toString().slice(-2); // พ.ศ. ใช้ 2 หลักท้าย
  const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0"); // เดือน 2 หลัก

  return { currentYear, shortYear, currentMonth };
};

const getMaxDocNo2 = async (prefix) => {
  const { shortYear } = getCurrentYearMonth2();

  // ตรวจสอบว่า prefix ถูกส่งเข้ามาหรือไม่
  if (!prefix) {
    console.error("🚨 prefix is undefined! Using default value.");
    prefix = "POM"; // ตั้งค่าเริ่มต้นเป็น POM ถ้า prefix ไม่ถูกกำหนด
  }

  try {
    // ดึงข้อมูลทั้งหมดจากฐานข้อมูล
    const findMaxDocNo = await getDataWithComp("PO_H", "");
    console.debug("findMaxDocNo", findMaxDocNo);

    // กรองเอกสารที่ตรงกับ prefix
    const filteredDocs = findMaxDocNo.filter((doc) =>
      doc.Doc_No.startsWith(prefix)
    );

    // ถ้าไม่มีเอกสารใดๆ ที่ตรงกับ prefix ให้เริ่มต้นจากปีปัจจุบัน + "0001"
    if (!filteredDocs || filteredDocs.length === 0) {
      console.warn(
        `No document found for ${prefix}, starting from:`,
        prefix + shortYear + "0001"
      );
      return prefix + shortYear + "0001";
    }

    // ค้นหา Doc_No ที่มี Doc_Id สูงสุด
    const latestDoc = filteredDocs.reduce(
      (max, item) => (item.Doc_Id > max.Doc_Id ? item : max),
      filteredDocs[0]
    );

    const latestDocNo = latestDoc?.Doc_No;

    // ถ้าไม่พบหมายเลขเอกสารที่ถูกต้อง ให้ใช้ค่า default
    if (!latestDocNo) {
      console.warn(
        `Invalid latestDocNo for ${prefix}, using default:`,
        prefix + shortYear + "0001"
      );
      return prefix + shortYear + "0001";
    }

    console.debug("✅ latestDocNo with highest Doc_Id:", latestDocNo);

    // ตรวจสอบปี ถ้าปีไม่ตรงให้รีเซ็ต
    // สมมติโครงสร้างเป็น Prefix(3) + Year(2) + Running(4)
    // แต่ถ้า prefix ยาวไม่เท่ากัน อาจต้องปรับ logic
    // ใช้ความยาว prefix ในการตัดปี
    const docYear = latestDocNo.slice(prefix.length, prefix.length + 2);
    if (docYear !== shortYear) {
      console.debug(`🔄 ปีใหม่ (${shortYear}) รีเซ็ตเลขรันสำหรับ ${prefix} (เดิม ${docYear})`);
      return prefix + shortYear + "0001";
    }

    // เพิ่มหมายเลขเอกสารขึ้น 1 โดยใช้ incrementDocNo2
    return incrementDocNo2(latestDocNo, prefix);
  } catch (error) {
    console.error("🚨 Error fetching max doc no:", error);
    return prefix + shortYear + "0001"; // ใช้ค่าเริ่มต้นหากเกิดข้อผิดพลาด
  }
};

// ✅ แก้ไข incrementDocNo2() ให้ดึงค่าตัวเลขถูกต้อง
const incrementDocNo2 = (docNo) => {
  console.debug("📌 Before increment: docNo =", docNo);

  const prefix = docNo.slice(0, 3); // เช่น "POM"
  const numPart = parseInt(docNo.slice(3), 10) + 1; // 0001 => 2

  console.debug("✅ Prefix:", prefix);
  console.debug("✅ Number Part After Increment:", numPart);

  return prefix + numPart.toString().padStart(4, "0");
};

const addTitleToDocNo = (newTitle, docNo) => {
  if (!docNo || docNo.length < 7) {
    // ถ้า docNo ไม่มีค่าหรือสั้นเกินไป ให้คืนค่าเดิม
    return newTitle + docNo;
  }

  // ตรวจสอบว่า docNo มี title (ตัวอักษร 2 ตัวแรก)
  const hasTitle = isNaN(docNo.substring(0, 3));

  if (hasTitle) {
    // ถ้ามี title (ตัวอักษร 2 ตัวแรก) ให้เปลี่ยน title ใหม่
    return newTitle + docNo.substring(3);
  } else {
    // ถ้าไม่มี title ให้เติม newTitle เข้าไปข้างหน้า
    return newTitle + docNo;
  }
};

// ฟังก์ชั่นเพิ่ม RecNo
const getMaxRecNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Rec_No > max ? item.Rec_No : max;
  }, list[0].Rec_No);

  // ตรวจสอบว่าเป็น RC หรือ REC เพื่อกำหนดตำแหน่ง slice
  const isRC = maxRec.startsWith("RC") && !maxRec.startsWith("REC");
  const yearIndex = isRC ? 2 : 3;
  const monthIndex = isRC ? 4 : 5;

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(yearIndex, yearIndex + 2) !== currentYear ||
    maxRec.slice(monthIndex, monthIndex + 2) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }



  return incrementRecNo(maxRec);
};
// ฟังก์ชั่นเพิ่ม RecNo สำหรับ Invoice
const getMaxRecNoForInv = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `RC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_INV_No > max ? item.Doc_INV_No : max;
  }, list[0].Doc_INV_No);

  const isRC = maxRec.startsWith("RC") && !maxRec.startsWith("REC");
  const yearIndex = isRC ? 2 : 3;
  const monthIndex = isRC ? 4 : 5;

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(yearIndex, yearIndex + 2) !== currentYear ||
    maxRec.slice(monthIndex, monthIndex + 2) !== currentMonth
  ) {
    return `RC${currentYear}${currentMonth}0001`;
  }

  // ถ้า prefix เป็น REC ให้เปลี่ยนเป็น RC ทันที (Migration)
  if (maxRec.startsWith("REC")) {
    const numPart = parseInt(maxRec.slice(7)) + 1;
    return `RC${currentYear}${currentMonth}${numPart.toString().padStart(4, "0")}`;
  }

  return incrementRecNo(maxRec);
};
// ฟังก์ชั่นเพิ่มเสริม RecNo
const incrementRecNo = (recNo) => {
  // ตรวจสอบว่าเป็น RC หรือ REC
  let sliceIndex = 7; // Default for REC (3 + 2 + 2)
  if (recNo.startsWith("RC") && !recNo.startsWith("REC")) {
    sliceIndex = 6; // RC (2 + 2 + 2)
  }

  const prefix = recNo.slice(0, sliceIndex); // รวมปีและเดือนใน prefix
  const numPart = parseInt(recNo.slice(sliceIndex)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นดึง Max ของ Pay
const getMaxPayNo = (list, givenDate) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  let year = currentYear;
  let month = currentMonth;
  if (givenDate) {
    const dateParts = givenDate.split("-");
    if (dateParts.length === 3) {
      month = dateParts[1];
      year = dateParts[2].slice(-2);
    }
  }

  const prefix = `PAY${year}${month}`;
  const runningNumbers = (list || [])
    .map((item) => item.Pay_No)
    .filter((payNo) => typeof payNo === "string" && payNo.startsWith(prefix))
    .map((payNo) => Number.parseInt(payNo.slice(prefix.length), 10))
    .filter((value) => Number.isInteger(value));
  const running = runningNumbers.length > 0 ? Math.max(...runningNumbers) : 0;

  return `${prefix}${(running + 1).toString().padStart(4, "0")}`;
};
// ฟังก์ชั่นเพิ่มเสริม PayNo
const incrementPayNo = (payNo) => {
  const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(payNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นดึง Max ของ Line
const getLineByDocId = async (table, docId) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-line-by-doc-id`,
      {
        table: table,
        doc_id: docId,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ฟังก์ชั่นเพิ่ม AdjNo
const getMaxAdjNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  const maxAdj = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxAdj.slice(3, 5) !== currentYear ||
    maxAdj.slice(5, 7) !== currentMonth
  ) {
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  return incrementAdjNo(maxAdj);
};
// ฟังก์ชั่นเพิ่มเสริม AdjNo
const incrementAdjNo = (adjNo) => {
  const prefix = adjNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(adjNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม TnsNo
const getMaxTnsNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `TNS${currentYear}${currentMonth}0001`;
  }

  const maxTns = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxTns.slice(3, 5) !== currentYear ||
    maxTns.slice(5, 7) !== currentMonth
  ) {
    return `TNS${currentYear}${currentMonth}0001`;
  }

  return incrementTnsNo(maxTns);
};
// ฟังก์ชั่นเพิ่มเสริม TnsNo
const incrementTnsNo = (tnsNo) => {
  const prefix = tnsNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(tnsNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For WD)
const getMaxWdNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "WD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "WD" + currentYear + currentMonth + "0001";
  }

  return incrementWdNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For WD)
const incrementWdNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For OD)
const getMaxOdNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OD" + currentYear + currentMonth + "0001";
  }

  return incrementOdNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For OD)
const incrementOdNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For IB)
const getMaxIbNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "IB" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "IB" + currentYear + currentMonth + "0001";
  }

  return incrementIbNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For IB)
const incrementIbNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For TE)
const getMaxTeNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "TE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "TE" + currentYear + currentMonth + "0001";
  }

  return incrementTeNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For TE)
const incrementTeNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For OE)
const getMaxOeNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OE" + currentYear + currentMonth + "0001";
  }

  return incrementOeNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For OE)
const incrementOeNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม INV_H (For CS)
const getMaxCsNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "CS" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "CS" + currentYear + currentMonth + "0001";
  }

  return incrementCsNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม INV_H (For CS)
const incrementCsNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม INV_H (For DSR)
const getMaxDsrNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    return `DSR${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `DSR${currentYear}${currentMonth}0001`;
  }

  return incrementDsrNo(maxRec);
};
// ฟังก์ชั่นเพิ่มเสริม INV_H (For DSR)
const incrementDsrNo = (invNo) => {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม InvNo
const getMaxInvNo = (list, givenDate) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();
  const dateParts = givenDate?.split("-") || [];
  const year = dateParts.length === 3 ? dateParts[2].slice(-2) : currentYear;
  const month = dateParts.length === 3 ? dateParts[1] : currentMonth;
  const prefix = `INV${year}${month}`;

  const matchingDocNos = (list || [])
    .map((item) => item.Doc_No)
    .filter((docNo) => typeof docNo === "string" && docNo.startsWith(prefix));
  const runningNumbers = matchingDocNos
    .map((docNo) => Number.parseInt(docNo.slice(prefix.length), 10))
    .filter((value) => Number.isInteger(value));
  const running = runningNumbers.length > 0 ? Math.max(...runningNumbers) : 0;
  const runningWidth = matchingDocNos.reduce(
    (width, docNo) => Math.max(width, docNo.length - prefix.length),
    2
  );

  return `${prefix}${(running + 1).toString().padStart(runningWidth, "0")}`;
};
// ฟังก์ชั่นเพิ่มเสริม InvNo
const incrementInvNo = (invNo) => {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(3, "0");
};

// ฟังก์ชัน randomDelay ใช้สำหรับทดสอบหน่วงเวลาดึงเลข Doc_No เบื้องต้น (ใช้ชั่วคราวไปก่อน)
const randomDelay = () => {
  // const delay = Math.floor(Math.random() * 5000); // สุ่มหน่วงเวลา 0-5000 มิลลิวินาที
  // console.debug(`Random delay: ${delay} ms`);
  // return new Promise((resolve) => setTimeout(resolve, delay));
  return new Promise((resolve) =>
    setTimeout(resolve, Math.floor(Math.random() * 5000))
  );
};

const getPriceForIce = (arCode, itemCode, itemQty) => {
  const aItemIce = ["101", "102", "103", "104"];

  let itemPrice = 0.0;
  let itemTotal = 0.0;
  let nPrice = 0.0;
  let cArSpriceUse = "N";
  let cItemSpriceUse = "Y";
  let nArSpriceId = 0;

  if (aItemIce.includes(itemCode)) {
    const result = getDataWithComp("Tb_Set_AR", `AND AR_Code = '${arCode}'`);

    if (result && result.length > 0) {
      nPrice = result[0].Default_Price || 0.0;
      cArSpriceUse = result[0].AR_SPrice_use || "N";
      nArSpriceId = result[0].AR_SPrice_id || 0;
    }
  }

  const itemResult = getDataWithComp(
    "Tb_Set_Item",
    `AND Item_Code = '${itemCode}'`
  );

  if (itemResult && itemResult.length > 0) {
    cItemSpriceUse = itemResult[0].Item_SPrice_use || "Y";
    const nItemId = itemResult[0].Item_Id || 0;

    if (nPrice === 0.0) {
      itemPrice = itemResult[0].Item_Price || 0.0;
    } else {
      itemPrice = nPrice;
    }

    let nProQty = 0.0;
    let nProPrice = 0.0;

    if (cArSpriceUse === "Y" && cItemSpriceUse === "Y") {
      const sPriceResult = getDataWithComp(
        "Tb_Set_ItemSPrice",
        `AND sp_id = ${nArSpriceId} AND item_id = ${nItemId}`
      );

      if (sPriceResult.length > 0) {
        nProQty = sPriceResult[0].pro_qty || 0.0;
        nProPrice = sPriceResult[0].pro_price || 0.0;

        if (sPriceResult[0].itemsp_price > 0.0) {
          itemPrice = sPriceResult[0].itemsp_price;
        }
      }
    }

    if (nProQty <= 0.0) {
      itemTotal = itemPrice * itemQty;
    } else {
      const n = Math.floor(itemQty / nProQty);
      itemTotal = n * nProPrice + (itemQty - n * nProQty) * itemPrice;
    }
  }

  return itemTotal;
};

// Update Status ในข้อมูล
const updateStatusByNo = async (table, field, status, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-status`,
      {
        table: table,
        field: field,
        status: status,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Update Qty ในข้อมูล
const updateQty = async (table, updateCode, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-qty`,
      {
        table: table,
        update_code: updateCode,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Insert ข้อมูลด้วย Table, Field, Values
const insertData = async (table, field, values) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-data`,
      {
        table: table,
        field: field,
        values: values,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Update ข้อมูลด้วย Table, Values, Where
// Update ข้อมูลด้วย Table, Values, Where
const updateData = async (table, values, where) => {
  try {
    console.log("UPDATE: values", values);

    // Helper to parse "key = value" string into object
    const parseStringToObject = (str, isWhere = false) => {
      if (typeof str !== 'string') return str;
      const obj = {};

      // Determine separator: ' AND ' for WHERE clause, ',' for SET clause
      // We use a regex that handles potential spacing around the separator
      const separator = isWhere ? /\s+AND\s+/i : /,(?=(?:(?:[^']*'){2})*[^']*$)/;

      const parts = str.split(separator);

      parts.forEach(part => {
        const [key, ...valParts] = part.split('=');
        if (key && valParts.length > 0) {
          let val = valParts.join('=').trim();
          // Remove surrounding quotes if present
          if ((val.startsWith("'") && val.endsWith("'")) || (val.startsWith('"') && val.endsWith('"'))) {
            val = val.slice(1, -1);
          }
          obj[key.trim()] = val;
        }
      });
      return obj;
    };

    const valuesObj = typeof values === 'string' ? parseStringToObject(values, false) : values;
    const whereObj = typeof where === 'string' ? parseStringToObject(where, true) : where;

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-data`,
      {
        table: table,
        values: valuesObj,
        where: whereObj,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Delete ข้อมูลด้วย Table, Where
const deleteData = async (table, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/delete`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

const createSetRecNo = async (recNo) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-tb-set-rec-no`,
      {
        rec_no: recNo,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

const getMaxRecNoForTest = (list, givenDate) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();
  const dateParts = givenDate?.split("-") || [];
  const year = dateParts.length === 3 ? dateParts[2].slice(-2) : currentYear;
  const month = dateParts.length === 3 ? dateParts[1] : currentMonth;
  const rcPrefix = `RC${year}${month}`;
  const recPrefix = `REC${year}${month}`;

  const runningNumbers = (list || [])
    .map((item) => item.RecNo)
    .filter((recNo) =>
      typeof recNo === "string" &&
      (recNo.startsWith(rcPrefix) || recNo.startsWith(recPrefix))
    )
    .map((recNo) =>
      Number.parseInt(
        recNo.slice(recNo.startsWith(recPrefix) ? recPrefix.length : rcPrefix.length),
        10
      )
    )
    .filter((value) => Number.isInteger(value));
  const running = runningNumbers.length > 0 ? Math.max(...runningNumbers) : 0;

  return `${rcPrefix}${(running + 1).toString().padStart(4, "0")}`;
};

export {
  getData,
  getDataWithComp,
  getDataWithJoin,
  countData,
  getByDocId,
  getByRecId,
  getByPayId,
  getCompany,
  getDocType,
  getTransType,
  getDocStatusColour,
  getViewPrH,
  getViewPoH,
  getViewAp,
  getViewItem,
  getSoWithoutPK,
  getCustByType,
  getEmpByType,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxDocNo,
  getMaxDocNoByDate,
  getMaxRecNo,
  getMaxRecNoForInv,
  getMaxPayNo,
  getLineByDocId,
  getMaxAdjNo,
  getMaxTnsNo,
  getMaxWdNo,
  getMaxOdNo,
  getMaxIbNo,
  getMaxTeNo,
  getMaxOeNo,
  getMaxCsNo,
  getMaxDsrNo,
  getMaxInvNo,
  getMaxDocInvNo,
  randomDelay,
  getPriceForIce,
  updateStatusByNo,
  updateQty,
  insertData,
  updateData,
  deleteData,
  addTitleToDocNo,
  getMaxDocNo2,
  createSetRecNo,
  getMaxRecNoForTest,
};
